import * as React from "react";
import "../../style/fonts.css";
import "./appHome.css";
import translate from "../../translations/i18n";
import smokelessLogo from "../../icons/smokeless_supporter_logo_v.svg";
import CtaButton from "../ctaButton/ctaButton";
import { Link } from "react-router-dom";

class AppHome extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="APP_HOME_CONT">
        <img src={smokelessLogo} className="APP_HOME_ICON" />
        <div className="APP_HOME_TEXT_CONT">
          <div className="REG_TEXT" style={{ opacity: 1 }}>
            {translate("SUPPORTER_APP_START_TEXT")}
          </div>
        </div>
        <div className="APP_HOME_START_CONT">
          <Link to="/overview">
            <CtaButton
              width={"280px"}
              text={translate("START")}
              color={"white"}
            />
          </Link>
        </div>
      </div>
    );
  }
}

export default AppHome;



// WEBPACK FOOTER //
// ./src/components/screens/appHome.tsx